export default "__VITE_ASSET__oDyKwgWj__"